import React, { Component } from 'react';
import {actions} from "@modules/wrap-redux/index";
import Header from './components/page-index/Header';
import GuessLike from './components/page-index/GuessLike';
import ChatArea from './components/page-index/ChatArea';
import InputArea from './components/page-index/InputArea';
import NewerGuide from './components/page-index/NewerGuide';

import createMsg from "@modules/createMsg";
import {setlog} from '@modules/58m';
import 'whatwg-fetch';

class PageIndex extends Component {
  constructor(){
    super();
    this.state={
      isShowGoBack:false,
    }
    setTimeout(setlog("mchatbot_home_show"),2000);
  }
  async componentDidMount(){
    //发送招呼消息
    let msg = createMsg({
      isShow:false,
      value:"pageInitialHelloMessage",
    })
   actions.chatAreaData.sendMsg({data:msg});
  }
  render() {
    //history 没用context 等16.7版本
    const {isShowGoBack} = this.state;
    return (
      <div className="robotchat-index-ui" id="robotchat-index-ui">
        <NewerGuide history={this.props.history}></NewerGuide>
        <Header history={this.props.history} isShowGoBack={isShowGoBack}></Header>
        <div className="scroller-wrap" id="scroller-wrap">
          <div className="loadHistory-tip">下拉可以查看历史记录</div>
          <div className="scroller" id="scroller">
            <GuessLike></GuessLike>
            <ChatArea history={this.props.history}></ChatArea>
          </div>
        </div>
        <InputArea></InputArea>
      </div>
    );
  }
}



export default PageIndex;

/**
 * 
 * state
 * {
 *  
 *  chatAreaRenderData:[{
 *    isFetching:true,
 *    input:{
 *      txt:"hello",
 *      isShow:true
 *    },
 *    reply:{
 *      data:[{type:-1},{}],
 *      isShow:true,
 *    }
 * }]
 *  inputAreaData:{
 *    val:'lalal',
 *    shortcuts:[]
 * }
 * }
 */

